/* =====================================================================
   COLDFRAME — 상품 목록(컬렉션·검색) 동작 (cf-collection.js)
   카페24 pages/js/product-list.js + product-list-filter.js 이식 (jQuery 없음)
   - 정렬 펼침, 필터 서랍 열기/닫기, 필터 항목 펼침, VIEW RESULT
   - 상품 이미지 2장 슬라이드, 상품명 높이 맞춤
   ===================================================================== */
(function () {
  'use strict';

  /* ---------------- 정렬 ---------------- */
  function initSort(root) {
    const wrap = root.querySelector('.sort-wrap');
    if (!wrap) return;
    const title = wrap.querySelector('.sort-title:not(.filter-title)');
    if (!title) return;
    const list = title.querySelector('.sort-list');
    const icon = title.querySelector('svg');

    const close = () => {
      if (!list) return;
      list.classList.remove('active');
      title.setAttribute('aria-expanded', 'false');
      if (icon) icon.style.transform = 'rotate(0deg)';
    };

    title.addEventListener('click', (e) => {
      if (e.target.closest('.sort-list a')) return;
      e.stopPropagation();
      if (!list) return;
      list.classList.toggle('active');
      const open = list.classList.contains('active');
      title.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (icon) icon.style.transform = open ? 'rotate(180deg)' : 'rotate(0deg)';
    });

    title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        title.click();
      }
    });

    // 정렬 링크: 현재 필터·검색어는 유지하고 정렬만 바꿈
    if (list) {
      list.querySelectorAll('a[data-sort]').forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', a.dataset.sort);
          url.searchParams.delete('page');
          close();
          window.location.href = url.toString();
        });
      });
    }

    document.addEventListener('click', close);
  }

  /* ---------------- 필터 서랍 ---------------- */
  function initFilter(root) {
    const panel = root.querySelector('#searchContent');
    const dimmed = root.querySelector('#filter-dimmed');
    const opener = root.querySelector('.sort-wrap .filter-title');
    if (!panel) return;

    const open = () => {
      panel.classList.add('active');
      if (dimmed) dimmed.classList.add('active');
      panel.setAttribute('aria-hidden', 'false');
    };
    const close = () => {
      panel.classList.remove('active');
      if (dimmed) dimmed.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    };

    if (opener) {
      opener.addEventListener('click', open);
      opener.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });
    }
    if (dimmed) dimmed.addEventListener('click', close);
    const cancel = panel.querySelector('.filter-top-wrap .cancel-btn');
    if (cancel) {
      cancel.addEventListener('click', close);
      cancel.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          close();
        }
      });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('active')) close();
    });

    // 항목 펼치기/접기 (카페24 ToggleFilterMenu)
    panel.querySelectorAll('th.title').forEach((th) => {
      th.addEventListener('click', () => {
        const tr = th.closest('tr');
        const td = tr && tr.querySelector('td');
        const icon = th.querySelector('.icon-chevron-down');
        if (!td) return;
        const visible = window.getComputedStyle(td).display !== 'none';
        if (visible) {
          if (icon) icon.classList.remove('rotated');
          td.style.overflow = 'hidden';
          td.style.height = td.scrollHeight + 'px';
          requestAnimationFrame(() => {
            td.style.transition = 'height 0.05s ease';
            td.style.height = '0px';
          });
          setTimeout(() => {
            td.style.display = 'none';
            td.style.height = '0';
            td.style.transition = '';
          }, 60);
        } else {
          if (icon) icon.classList.add('rotated');
          td.style.display = 'block';
          td.style.height = '0px';
          td.style.overflow = 'hidden';
          const target = td.scrollHeight;
          requestAnimationFrame(() => {
            td.style.transition = 'height 0.2s ease';
            td.style.height = target + 'px';
          });
          setTimeout(() => {
            td.style.height = 'auto';
            td.style.overflow = 'visible';
            td.style.transition = '';
          }, 210);
        }
      });
    });

    // 체크 상태 표시 (카페24 initFilterCheckboxes)
    panel.querySelectorAll('.xans-product-filterform input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {
        const li = input.closest('li');
        if (input.checked) {
          input.classList.add('selected');
          input.setAttribute('checked', 'checked');
          if (li) li.classList.add('selected');
        } else {
          input.classList.remove('selected');
          input.removeAttribute('checked');
          if (li) li.classList.remove('selected');
        }
      });
    });

    // VIEW RESULT
    const form = panel.querySelector('form.searchCondition');
    const submit = panel.querySelector('#filter-footer .btnSubmit');
    if (form && submit) {
      submit.addEventListener('click', () => {
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() === '') return;
          params.append(key, value);
        });
        const action = form.getAttribute('action') || window.location.pathname;
        const query = params.toString();
        window.location.href = action + (query ? (action.includes('?') ? '&' : '?') + query : '');
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        submit.click();
      });
    }
  }

  /* ---------------- 상품 이미지 슬라이드 (카페24 setupProductSwiper) ---------------- */
  function initProductSwipers(root) {
    if (typeof window.Swiper !== 'function') return;
    root.querySelectorAll('.product-swiper').forEach((el) => {
      if (el.swiper) return;
      // 슬라이드 사이 공백 텍스트 제거
      el.querySelectorAll('.swiper-slide').forEach((slide) => {
        Array.from(slide.childNodes).forEach((node) => {
          if (node.nodeType === 3) node.remove();
        });
      });

      const slides = el.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      const paginationEl = el.querySelector('.swiper-custom-pagination');
      if (paginationEl) {
        let bulletWidth;
        if (slideCount === 4) bulletWidth = '25%';
        else if (slideCount === 3) bulletWidth = '33.3334%';
        else bulletWidth = 100 / Math.max(slideCount, 1) + '%';
        paginationEl.style.setProperty('--bullet-width', bulletWidth);
      }

      // 화살표를 눌러도 상품 페이지로 이동하지 않도록
      el.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-custom-pagination').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
      });

      if (slideCount < 2) {
        el.classList.add('cf-single');
        return;
      }

      // eslint-disable-next-line no-new
      new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
      });
    });
  }

  /* ---------------- 상품명 높이 맞춤 ---------------- */
  function syncNames(root) {
    if (typeof window.CfxGridHeightSync !== 'function') return;
    const col = window.matchMedia('(max-width: 767px)').matches ? 2 : 4;
    root.querySelectorAll('.ec-base-product .prdList').forEach((grid) => {
      // eslint-disable-next-line no-new
      new window.CfxGridHeightSync(grid, '.description > .p-name', col);
    });
  }

  /* ---------------- 소재 줄 높이 맞춤 (2026-10-26) ----------------
     소재 줄은 최대 2줄. 같은 줄(행)에 있는 카드끼리 소재 줄 높이를 가장 큰 값으로 맞춰
     가격 위치가 행 안에서 어긋나지 않게 합니다. 행은 카드의 실제 위치로 나눕니다. */
  function syncSubnames(root) {
    root.querySelectorAll('.ec-base-product .prdList').forEach((grid) => {
      const spans = Array.from(grid.querySelectorAll('.description li.listSubname > span'));
      spans.forEach((s) => {
        s.style.height = '';
      });
      const items = [];
      spans.forEach((s) => {
        const card = s.closest('.prdList > li') || s;
        if (!card.offsetParent) return;
        items.push({ s, top: card.getBoundingClientRect().top + window.scrollY });
      });
      items.sort((a, b) => a.top - b.top);
      const rows = [];
      items.forEach((it) => {
        const last = rows[rows.length - 1];
        if (last && Math.abs(last.top - it.top) < 2) last.items.push(it.s);
        else rows.push({ top: it.top, items: [it.s] });
      });
      rows.forEach((row) => {
        if (row.items.length < 2) return;
        const max = Math.max(...row.items.map((s) => s.offsetHeight));
        row.items.forEach((s) => {
          if (s.offsetHeight < max) s.style.height = max + 'px';
        });
      });
    });
  }

  function init(scope) {
    const roots = (scope || document).querySelectorAll('[data-cf-collection]');
    roots.forEach((root) => {
      if (root.dataset.cfInit === '1') return;
      root.dataset.cfInit = '1';
      initSort(root);
      initFilter(root);
      initProductSwipers(root);
      syncNames(root);
      syncSubnames(root);
    });
  }

  function start() {
    init(document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        document.querySelectorAll('[data-cf-collection]').forEach((root) => {
          syncNames(root);
          syncSubnames(root);
        });
      });
    }

    // 창 너비가 바뀌면(회전·창 크기 조절) 상품명·소재 줄 높이를 다시 맞춤. 높이만 바뀌는 경우(모바일 주소창)는 건너뜀
    let lastWidth = window.innerWidth;
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('[data-cf-collection]').forEach((root) => {
          syncNames(root);
          syncSubnames(root);
        });
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
